import './App.less'
import './App-ar.less'
import Home from './components/Home'

function App(props) {
  return <Home {...props} />
}

export default App
